
interface RecommendedShopsProps {
  selectedServices: string[];
  selectedDate: string;
  selectedTime: string;
}

export default function RecommendedShops({ selectedServices, selectedDate, selectedTime }: RecommendedShopsProps) {
  const allShops = [
    {
      id: 1,
      name: '다움네일살롱',
      location: '강남구 청담동',
      address: '서울 강남구 청담동 123-45',
      services: ['nail'],
      rating: 4.9,
      reviewCount: 328,
      distance: '0.5km',
      image: 'https://public.readdy.ai/ai/img_res/252e34dcaa166cd95bdb022e0785cacf.jpg',
      specialty: '프렌치네일 디자인으로 유명한 프리미엄 샵',
      availableSlots: 3
    },
    {
      id: 2,
      name: '라벤더 아이래쉬',
      location: '마포구 홍대입구',
      address: '서울 마포구 서교동 456-78',
      services: ['eyelash'],
      rating: 4.8,
      reviewCount: 256,
      distance: '1.2km',
      image: 'https://readdy.ai/api/search-image?query=Modern%20eyelash%20extension%20salon%20with%20soft%20lavender%20and%20white%20tones%2C%20comfortable%20treatment%20bed%2C%20professional%20lighting%2C%20minimalist%20beauty%20studio%2C%20elegant%20feminine%20design%2C%20premium%20lash%20service%20space%2C%20serene%20atmosphere%2C%20clean%20aesthetic&width=400&height=300&seq=booking-shop-lash-1&orientation=landscape',
      specialty: '자연스러운 속눈썹 연장 전문',
      availableSlots: 5
    },
    {
      id: 3,
      name: '로즈 스킨케어',
      location: '강남구 압구정동',
      address: '서울 강남구 압구정로 789-12',
      services: ['skincare'],
      rating: 5.0,
      reviewCount: 412,
      distance: '0.8km',
      image: 'https://readdy.ai/api/search-image?query=Premium%20skincare%20spa%20room%20with%20rose%20gold%20accents%2C%20soft%20pink%20lighting%2C%20luxury%20facial%20treatment%20bed%2C%20elegant%20minimalist%20interior%2C%20professional%20beauty%20clinic%2C%20warm%20beige%20tones%2C%20sophisticated%20wellness%20space%2C%20serene%20healing%20atmosphere&width=400&height=300&seq=booking-shop-skin-1&orientation=landscape',
      specialty: '맞춤형 피부관리와 힐링 케어',
      availableSlots: 2
    },
    {
      id: 4,
      name: '블룸 왁싱 스튜디오',
      location: '강남구 신사동',
      address: '서울 강남구 신사동 321-54',
      services: ['waxing'],
      rating: 4.9,
      reviewCount: 189,
      distance: '1.5km',
      image: 'https://readdy.ai/api/search-image?query=Private%20waxing%20studio%20with%20soft%20pastel%20colors%2C%20clean%20modern%20design%2C%20comfortable%20treatment%20room%2C%20professional%20beauty%20space%2C%20minimalist%20aesthetic%2C%20warm%20lighting%2C%20elegant%20feminine%20interior%2C%20premium%20personal%20care%20salon&width=400&height=300&seq=booking-shop-wax-1&orientation=landscape',
      specialty: '프라이빗한 공간에서 편안한 왁싱',
      availableSlots: 4
    },
    {
      id: 5,
      name: '페탈 헤어살롱',
      location: '강남구 청담동',
      address: '서울 강남구 청담동 654-32',
      services: ['hair'],
      rating: 4.8,
      reviewCount: 294,
      distance: '0.6km',
      image: 'https://readdy.ai/api/search-image?query=Chic%20hair%20salon%20with%20pastel%20pink%20and%20beige%20interior%2C%20modern%20styling%20stations%2C%20elegant%20mirrors%2C%20professional%20beauty%20space%2C%20sophisticated%20feminine%20design%2C%20soft%20ambient%20lighting%2C%20premium%20hairdressing%20studio%2C%20minimalist%20aesthetic&width=400&height=300&seq=booking-shop-hair-1&orientation=landscape',
      specialty: '트렌디한 컷과 컬러 전문',
      availableSlots: 6
    },
    {
      id: 6,
      name: '오로라 메이크업',
      location: '강남구 가로수길',
      address: '서울 강남구 신사동 987-65',
      services: ['makeup'],
      rating: 5.0,
      reviewCount: 167,
      distance: '1.0km',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20makeup%20studio%20with%20soft%20lighting%2C%20professional%20vanity%20mirror%2C%20pastel%20pink%20and%20gold%20accents%2C%20luxury%20cosmetics%20display%2C%20sophisticated%20beauty%20space%2C%20feminine%20minimalist%20design%2C%20premium%20bridal%20makeup%20room%2C%20warm%20atmosphere&width=400&height=300&seq=booking-shop-makeup-1&orientation=landscape',
      specialty: '웨딩 및 특별한 날 메이크업',
      availableSlots: 3
    },
    {
      id: 7,
      name: '벨라 네일 & 래쉬',
      location: '강남구 역삼동',
      address: '서울 강남구 역삼동 234-56',
      services: ['nail', 'eyelash'],
      rating: 4.9,
      reviewCount: 445,
      distance: '0.9km',
      image: 'https://readdy.ai/api/search-image?query=Combined%20nail%20and%20eyelash%20salon%20with%20elegant%20pink%20and%20white%20interior%2C%20dual%20service%20stations%2C%20modern%20minimalist%20design%2C%20professional%20beauty%20space%2C%20sophisticated%20feminine%20atmosphere%2C%20premium%20multi-service%20studio%2C%20clean%20aesthetic&width=400&height=300&seq=booking-shop-multi-1&orientation=landscape',
      specialty: '네일과 속눈썹을 한 번에',
      availableSlots: 4
    },
    {
      id: 8,
      name: '글로우 토탈뷰티',
      location: '강남구 논현동',
      address: '서울 강남구 논현동 567-89',
      services: ['nail', 'skincare', 'waxing'],
      rating: 4.8,
      reviewCount: 523,
      distance: '1.3km',
      image: 'https://readdy.ai/api/search-image?query=Comprehensive%20beauty%20salon%20with%20multiple%20service%20areas%2C%20elegant%20pastel%20interior%2C%20modern%20minimalist%20design%2C%20professional%20multi-service%20space%2C%20sophisticated%20feminine%20atmosphere%2C%20premium%20total%20beauty%20studio%2C%20warm%20lighting%2C%20clean%20aesthetic&width=400&height=300&seq=booking-shop-total-1&orientation=landscape',
      specialty: '토탈 뷰티 케어 전문',
      availableSlots: 7
    }
  ];

  const filteredShops = allShops.filter(shop => 
    selectedServices.some(service => shop.services.includes(service))
  );

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return `${date.getMonth() + 1}월 ${date.getDate()}일`;
  };

  return (
    <section className="mb-12">
      <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-3xl p-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-2xl font-medium text-gray-800 mb-2">추천 매장</h2>
            <p className="text-sm text-gray-600">
              {formatDate(selectedDate)} {selectedTime} 예약 가능한 매장이에요
            </p>
          </div>
          <div className="bg-white px-4 py-2 rounded-full shadow-sm">
            <span className="text-sm font-medium text-rose-400">{filteredShops.length}개 매장</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {filteredShops.map((shop) => (
            <div
              key={shop.id}
              className="bg-white rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300"
            >
              <div className="relative w-full h-48">
                <img
                  src={shop.image}
                  alt={shop.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full">
                  <span className="text-xs font-medium text-gray-800">{shop.distance}</span>
                </div>
                <div className="absolute top-4 right-4 bg-gradient-to-r from-rose-400 to-pink-400 text-white px-3 py-1.5 rounded-full">
                  <span className="text-xs font-medium">{shop.availableSlots}개 시간 가능</span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h3 className="text-xl font-medium text-gray-800 mb-1">{shop.name}</h3>
                    <div className="flex items-center space-x-2">
                      <i className="ri-map-pin-line text-gray-500 text-sm"></i>
                      <span className="text-sm text-gray-600">{shop.location}</span>
                    </div>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-star-fill text-yellow-400 text-lg"></i>
                    <span className="text-base font-medium text-gray-800">{shop.rating}</span>
                  </div>
                </div>

                <p className="text-sm text-gray-700 mb-4 leading-relaxed">{shop.specialty}</p>

                <div className="flex items-center space-x-2 mb-4">
                  {shop.services.map((service) => {
                    const serviceNames: { [key: string]: string } = {
                      nail: '네일',
                      eyelash: '속눈썹',
                      waxing: '왁싱',
                      skincare: '피부관리',
                      hair: '헤어',
                      makeup: '메이크업'
                    };
                    return (
                      <span
                        key={service}
                        className="text-xs font-medium text-rose-400 bg-rose-50 px-3 py-1 rounded-full"
                      >
                        {serviceNames[service]}
                      </span>
                    );
                  })}
                </div>

                <button className="w-full py-3 bg-gradient-to-r from-rose-400 to-pink-400 text-white text-sm font-medium rounded-full hover:shadow-lg hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
                  <i className="ri-calendar-check-line mr-2"></i>
                  바로 예약하기
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
